module.exports = __webpack_public_path__ + "img/siren.1d7e98bd.svg";